export class Config {
    authApi: string = '';
    /** bela-belleza-api: URL en claro (se rellena desde localStorage; el login guarda el Base64 de `SERVICES_API_URL`). No configurar en environment. */
    servicesAPI: string = '';
    secret: string = '';
    version: string = '';

    /** Si la barra lateral es fija (siempre visible, expandible/colapsable). false = no fija (menú en panel overlay). Definido al inicio por ambiente. */
    sidebarFixed: boolean = true;
}
